import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Store } from "@ngrx/store";
import { RouterOutlet } from "@angular/router";
import { NgClass } from "@angular/common";

@Component({
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, RouterOutlet],
})
export class AuthLayout implements OnInit {
  store: any;

  constructor(public readonly storeData: Store<any>) {}

  ngOnInit() {
    this.initStore();
    this.toggleLoader();
  }

  toggleLoader() {
    this.storeData.dispatch({ type: "toggleMainLoader", payload: true });
    setTimeout(() => {
      this.storeData.dispatch({ type: "toggleMainLoader", payload: false });
    }, 500);
  }

  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }
}
